export default {
    name: 'calculate',
    serverName: '/api/v1/calculator/calculator/',
    apiUrl: '/api/v1/calculator/calculator/'
};
